export const DEFAULT_TOAST_DURATION = 5000; // time in ms
